import axios from 'axios';
import { SearchPlaceDTO } from './dto';
import { placesUrl } from '../../conf';
import { AxiosContext } from '../../providers/axiosContext';
import { useContext } from 'react';

export interface PlacesSearchService {
  fetchResults: (
    search?: string,
    coords?: { lat: number; lng: number }
  ) => Promise<SearchPlaceDTO>;
}

export const usePlacesSearchService = (): PlacesSearchService => {
  const axiosContext = useContext(AxiosContext);

  const fetchResults = async (
    search: string,
    coords?: { lat: number; lng: number }
  ) => {
    const res = await axiosContext.newAuthAxios.get(placesUrl, {
      params: {
        query: search,
        lat: coords?.lat,
        lng: coords?.lng,
      },
    });
    return res.data;
  };

  return { fetchResults };
};
